export const markFormClick = function (name) {
  window.dataLayer.push({
    event: "page_view",
    pageName: name,
    pageType: "contact",
  })
}
